import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Cadastro de malhas, variáveis e fórmulas",
    correct: false,
  },
  {
    option: "b) Cálculo de parâmetros do controlador PID",
    correct: true,
  },
  {
    option: "c) Consulta de dados históricos de processo",
    correct: false,
  },
  {
    option: "d) Cálculo dos indicadores técnicos das malhas",
    correct: false,
  },
  {
    option:
      "e) Correlação entre indicadores técnicos e indicadores do processo",
    correct: false,
  },
];

export default function Question17(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question17: {
          title:
            "Quais ganhos dessas funcionalidades não está presente no SAI Smart Loop atualmente?",
          option: option.option,
          correct: option.correct,
          order: 17
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Quais ganhos dessas funcionalidades não está presente no SAI Smart Loop atualmente?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
